import { render, staticRenderFns } from "./CompanyPersonsPostInfo.vue?vue&type=template&id=4194b68d&scoped=true&"
import script from "./CompanyPersonsPostInfo.vue?vue&type=script&lang=js&"
export * from "./CompanyPersonsPostInfo.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPersonsPostInfo.vue?vue&type=style&index=0&id=4194b68d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4194b68d",
  null
  
)

export default component.exports